import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbstractServiceAdvertisement } from './advertisement.service.abstract';
import { ModelResponseDeleteAdvertisement } from '../../models/http-responses/delete-advertisement-response.model';
import { AbstractEndpoints } from '../endpoints/endpoints.service.abstract';
import { AppConfig } from '../../app-services/config/config.app';

export class ServiceAdvertisements implements AbstractServiceAdvertisement {

  constructor(private endpoints: AbstractEndpoints, private http: HttpClient, private appConfig: AppConfig) { }

  deleteAdvertisement(organizationId: string, advertisementId: string): Observable<ModelResponseDeleteAdvertisement> {
    return this.http.delete<ModelResponseDeleteAdvertisement>(this.endpoints.advertisement.deleteAdvertisement(organizationId, advertisementId));
  }
}
